<template>
    <div class="modal" v-if="ticket">
        <div class="modal__container">
            <div class="modal__inner  modal__inner--secondary">
                <div class="flex justify-end">
                    <a href="#" class="modal__close-top" @click.prevent="close">
                        <i class="fas fa-times"></i>
                        <span>{{ __('Cancel') }}</span>
                    </a>
                </div>

                <h3 class="modal__ttl  modal__ttl--primary">{{ ticket.type }}</h3>
                <h4 class="modal__ttl  modal__ttl--primary">Please configure your tickets</h4>

                <form class="form  form--primary" id="options-form">
                    <table>
                        <tbody>
                            <template v-for="(ticket, ticketIndex) in individualTickets">
                                <tr :key="'ticket_heading' + ticketIndex" v-show="individualTickets.length > 0">
                                    <td class="font-bold text-center" colspan="2">
                                        Ticket {{ ticketIndex + 1 }}
                                    </td>
                                </tr>
                                <tr v-for="(option, i) in ticket.options" :key="'ticket_option' + ticketIndex + '_' + i">
                                    <template>
                                        <td class="text-right text-darker">
                                            <span>{{ option.name }}:</span>
                                        </td>
                                        <td class="py-0">
                                            <div class="form__field mb-0">
                                                <select v-model="option.selected"
                                                    :name="'ticket_option_' + i + '_select'"
                                                    :id="'ticket_option_' + i + '_select'"
                                                    class="form__input  form__input--quaternary option-select">
                                                    <option :value="undefined">Please choose</option>
                                                    <template v-for="availableChoice in option.choices">
                                                        <option
                                                            :value="availableChoice"
                                                            :disabled="!productStockIsAvailable(availableChoice)"
                                                            :key="'ticket_option_' + i + '_' + availableChoice.name"
                                                            v-html="optionLabel(availableChoice)">
                                                        </option>
                                                    </template>
                                                </select>
                                            </div>
                                        </td>
                                    </template>
                                </tr>
                            </template>
                            <tr class="form-error-message" v-show="formError">
                                <td colspan="2">
                                    <div class="form__error">
                                        <p>Please make your choices</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right" colspan="2">
                                    <button class="btn  btn--quaternary" @click.prevent="addToBasket">{{ __('Add to Basket') }}</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>

                <div class="flex justify-end">
                    <a href="#" class="modal__close-bottom" @click.prevent="close">
                        <i class="fas fa-times"></i>
                        <span>{{ __('Cancel') }}</span>
                    </a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'seat-picker-modal',

        props: {
            activeTicket: {
                type: Object,
                default: false
            }
        },

        data: (instance) => {
            let ticket = Object.assign({}, instance.activeTicket);
            let individualTickets = [];

            let available = ticket.available;
            while(ticket.selectedQty > individualTickets.length){
                let individualTicket = _.cloneDeep(ticket);
                individualTicket.selectedQty = 1;
                individualTicket.available = available--;
                individualTickets.push(individualTicket);
            }

            return {
                currency: window.currency,
                ticket: ticket,
                individualTickets: individualTickets,
                formError: false,
                productStocks: {},
            }
        },
        mounted: function() {
            this.fetchProductStocks();
        },
        computed: {
            optionsSelected()  {
                return this.individualTickets && this.individualTickets.every((ticket) => ticket.options.every((option) => option.selected))
            }
        },
        methods: {
            close() {
                this.$emit('close', true);
            },
            addToBasket() {
                if(!this.optionsSelected) {
                    this.formError = true;
                    return;
                }

                this.$emit('addToBasket', this.individualTickets);
            },
            setQuantity(amount){
                this.ticket.selectedQty = Math.min(this.ticket.originalAvailable, amount);
            },
            optionLabel(availableOption){
                var price = parseFloat(availableOption.price).toFixed(2);
                return availableOption.name + ((price > 0) ? ' (' + ((this.ticket.price != 0) ? '+' : '') + this.currency.symbol + '' + price + ')' : '');
            },
            isAnOptionSelected(index) {
                if (this.onlyAllowOneOption) {
                    return this.individualTickets && this.individualTickets[index].options.some((option) => option.selected);
                }
            },
            async fetchProductStocks() {
                let productStockIds = [];
                productStockIds = this.activeTicket.options.flatMap(
                    option => option.choices.map(choice => choice.product_stock_id).filter(value => value)
                );
                if (productStockIds.length) {
                    let response = await axios.post("/product-stock", {
                        product_stock_ids: productStockIds
                    }).catch(e => {
                    });
                    this.productStocks = response.data;
                }
            },
            productStockIsAvailable(option) {
                if (!option.product_stock_id || !this.productStocks[option.product_stock_id]) {
                    return true;
                }
                let isAvailable = this.productStocks[option.product_stock_id].quantity > this.productStocks[option.product_stock_id].sold_quantity;
                return isAvailable;
            }
        }
    }
</script>
<style lang="scss" scoped>
@import "../../sass/base/_variables.scss";
    #options-form {
        max-height: 60vh;
        overflow-y: auto;
    }
    h4{
        &.modal__ttl--primary{
            font-size: 24px;
        }
    }
    table{
        margin: 0 auto;
        td{
            padding: 10px;
        }
        select{
            font-size: 16px;
        }
    }
    .qty_options{
        display: inline-block;
        margin-right: 10px;

        .qty_options__option {
            cursor: pointer;
            user-select: none;
            padding: 8px 8px;
            background: #e2e2e2;
            border-radius: 50%;
            -webkit-transition: all .2s ease-in-out;
            transition: all .2s ease-in-out;
        }
        .qty_options > * {
            display: inline-block;
            vertical-align: middle;
            font-size: 1rem;
        }
        .qty_options__number {
            padding: 0 10px;
        }
    }
    .option-select{
        min-width: 200px;
    }
    .modal__close-bottom {
        color: $secondary-colour;
        margin-top: 40px;
    }
    .modal__close-top {
        margin-bottom: 20px;
    }
    .form-error-message {
        text-align: center;
    }
    .form__error {
        p {
            font-size: 18px;
            font-weight: bold;
        }
    }
    .theme-crabfeast select{
        color:black!important;
    }
    .font-bold{
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/SeatPickerModal.vue